var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFecharMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-275 -35) matrix(-1 0 0 1 293 34) translate(0 .554)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.81,
    height: 2.138,
    x: -2,
    y: 8,
    rx: 1.069,
    transform: "rotate(-45 9.405 9.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.81,
    height: 2.138,
    x: -1.81,
    y: 8,
    rx: 1.069,
    transform: "scale(-1 1) rotate(-45 0 32.234)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFecharMenuIcon);
export default __webpack_public_path__ + "static/media/fechar-menu-icon.3ae6f150581d439ffc12c2c4cbf209fe.svg";
export { ForwardRef as ReactComponent };